import { render, staticRenderFns } from "./Generica.vue?vue&type=template&id=7ff88aa4&scoped=true&"
import script from "./Generica.vue?vue&type=script&lang=js&"
export * from "./Generica.vue?vue&type=script&lang=js&"
import style0 from "./Generica.vue?vue&type=style&index=0&id=7ff88aa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff88aa4",
  null
  
)

export default component.exports